module.exports = __webpack_public_path__ + "img/每日签到.5f9bf21b.svg";